import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ColumnDescriptor } from '../data-table.component';

@Component({
    selector: 'columns-select',
    templateUrl: './columns-select.component.html'
})
export class ColumnsSelectComponent {
    columns: { name: string, descriptor: ColumnDescriptor }[] = [];
    constructor(@Inject(MAT_DIALOG_DATA) data: any) {
        Object.keys(data).forEach(k => {
            if (typeof data[k] == 'number')
                data[k] = {}
            if (data[k].visible == null) data[k].visible = true;
            this.columns.push({ name: k, descriptor: data[k] });
        });
    }
}